import { render } from "./Uprofile.vue?vue&type=template&id=3a1f4bf7&scoped=true"
import script from "./Uprofile.vue?vue&type=script&lang=js"
export * from "./Uprofile.vue?vue&type=script&lang=js"

import "./Uprofile.vue?vue&type=style&index=0&id=3a1f4bf7&scoped=true&lang=css"
import "./Uprofile.vue?vue&type=style&index=1&id=3a1f4bf7&scoped=true&lang=css"

import exportComponent from "/Users/iammaham/Documents/JS/estate_soluce/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a1f4bf7"]])

export default __exports__